import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { useTheme } from '../context/ThemeContext';

const SuccessStoriesPage = () => {
  const { theme } = useTheme();

  return (
    <>
      <Helmet>
        <title>Success Stories | BookMyAudition</title>
      </Helmet>
      <div 
        className="success-stories-page" 
        style={{ 
          minHeight: '70vh', 
          padding: '60px 0',
          backgroundColor: theme === 'dark' ? '#0a0a14' : '#f8fafc',
          color: theme === 'dark' ? '#f8fafc' : '#111'
        }}
      >
        <Container>
          <Row className="justify-content-center text-center">
            <Col md={8}>
              <h1 className="fw-bold mb-4" style={{ color: theme === 'dark' ? '#fff' : '#111' }}>
                Inspiring Success Stories
              </h1>
              <p style={{ color: theme === 'dark' ? '#cbd5e1' : '#475569', fontSize: '1.1rem' }}>
                From local auditions to the big screen. Read about the talented actors who found their breakthrough through BookMyAudition.
              </p>
              
              <div 
                className="coming-soon-box mt-5 p-5 rounded-4 shadow-sm"
                style={{
                  backgroundColor: theme === 'dark' ? '#111116' : '#fff',
                  border: `1px solid ${theme === 'dark' ? '#1f1f2e' : '#eaeaea'}`
                }}
              >
                <div 
                  className="d-inline-block mb-3 px-3 py-1 rounded-pill" 
                  style={{ 
                    backgroundColor: 'rgba(34, 197, 94, 0.1)', 
                    color: '#22c55e',
                    fontSize: '0.85rem',
                    fontWeight: '600',
                    border: '1px solid rgba(34, 197, 94, 0.2)'
                  }}
                >
                  REAL JOURNEYS
                </div>
                <h3 className="fw-bold mb-3">Capturing Greatness</h3>
                <p className="mb-0 text-muted">
                  We are currently documenting the amazing journeys of our community members. Your story could be the next one featured here!
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default SuccessStoriesPage;